<template>
  <div>
    <v-autocomplete
      :value="value"
      :items="icons"
      item-text="name"
      :item-value="item => 'mdi-' + item.name"
      :filter="customFilter"
      :loading="!!!icons.length"
      :label="label"
      :error-messages="errorMessages"
      :cache-items="true"
      v-bind="$attrs"
      v-on="$listeners"
      @input="$emit('input', $event)"
    >
      <template slot="selection" slot-scope="data">
        <v-icon color="#000000" class="mr-2">mdi-{{ data.item.name }}</v-icon>
        {{ data.item.name }}
      </template>
      <template slot="item" slot-scope="data">
        <v-icon color="#000000" class="mr-2">mdi-{{ data.item.name }}</v-icon>
        {{ data.item.name }}
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { version } from '@mdi/font/package.json';
import axios from 'axios';
import { mapCacheActions } from 'vuex-cache';
import { mapState } from 'vuex';

export default {
  name: 'IconSelect',

  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState(['loading']),
    ...mapState('icons', ['icons'])
  },

  data: () => ({}),

  mounted() {
    this.getIcons({params: { version: version }})
      .then(({ data }) => {})
      .catch(error => {
        this.error = error;
      });
  },

  methods: {
    ...mapCacheActions('icons', ['getIcons']),
    customFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    },
    setIcons() {
      //old realisation
      axios
        //http://dev.materialdesignicons.com/contribute/third-party#cdn
        .get(`https://cdn.jsdelivr.net/npm/@mdi/svg@${version}/meta.json`)
        //.get(`https://cdn.materialdesignicons.com/${version}/meta.json`)
        .then(response => {
          this.icons = response.data;
        });
    }
  }
};
</script>
